<template>
  <div class="userList">
    <UserEnterprise @success="getList" ref="userEnterprise"/>
    <UserIntegral ref="userIntegral"/>
    <ReceivingAddress ref="ReceivingAddress"/>
    <FilterForm :fields="searchFields" @submit="search"/>
    <BasicTable
    hasOperate
    :border="false"
    customClass="table"
    :tableData="tableData"
    :treeProps="{ children: 'sub', hasChildren: 'hasChildren' }"
    :columns="columns"
    :pageSize="+pageOption.page_size"
    :currentPage="+pageOption.page"
    :total="+pageOption.total"
    :loading="loading"
    @pageChange="pageChange">
    <template slot="tableOpeate">
      用户列表&emsp;
      <AppButton size="small" type="primary" plain @click="editUser('add',{})"><i class="fa fa-plus fa-lg icon" ></i>新增</AppButton>&emsp;
    </template>
    <template v-slot:baseInfo="{ item }">
      <div class="baseInfo">
        <el-avatar :size="'medium'" :src="item.head_pic"></el-avatar>
        <div class="content">
          <div>{{item.nickname}}</div>
          <div>{{item.email}}</div>
        </div>
      </div>
    </template>
    <template v-slot:sex="{ item }">
      {{item.sex === 1 ? '男' : '女'}}
    </template>
    <template v-slot:is_apply="{ item }">
      <el-tag
        :type="item.is_apply === 3 ? 'danger' : item.is_apply === 2 ? 'success' : item.is_apply === 0 ? 'info': item.is_apply === 1 ? '': 'warning'"
        effect="dark">
        {{status[item.is_apply]}}
      </el-tag>
    </template>
    <template v-slot:operate="{ item }">
      <AppButton type="primary" plain size="small" @click="editUser('edit',item)"><i class="fa fa-edit fa-lg icon" ></i>编辑</AppButton>
      <AppButton type="primary" v-if="item.is_apply > 0 && item.is_apply < 4" plain size="small" @click="openReadEnterprise(item)">查看企业</AppButton>
      <el-dropdown @command="menuClick" style="margin-left: 10px">
        <AppButton type="primary" plain size="small">
          操作<i class="el-icon-arrow-down el-icon--right"></i>
        </AppButton>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item :command="{item, key: 1}" v-if="item.is_apply === 1">审核</el-dropdown-item>
          <el-dropdown-item :command="{item, key: 2}">{{item.is_apply === 0 ? '上传' : '更改'}}企业信息</el-dropdown-item>
          <el-dropdown-item :command="{item, key: 3}">积分列表</el-dropdown-item>
          <el-dropdown-item :command="{item, key: 4}">收货地址</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </template>
    </BasicTable>
  </div>
</template>

<script>
import UserEnterprise from './userEnterprise.vue';
import UserIntegral from './userIntegral.vue';
import ReceivingAddress from './receivingAddress.vue';
import { UserService } from '../../service/user.service';
const status = [
  '未申请',
  '待审核',
  '审核通过',
  '审核拒绝',
  '撤回',
  '证件过期',
]
const searchFields = [
  { name: '用户名', key: 'username', type: 'input' },
  { name: '昵称', key: 'nickname', type: 'input' },
  { name: '手机号', key: 'mobile', type: 'input' },
  { name: '邮箱', key: 'email', type: 'input' },
  { name: '会员等级', key: 'level', type: 'input' },
  { name: '审核状态', key: 'is_apply', type: 'select', options: status.map((v, i) => ({value: i, label: v })) },
  { name: '账号状态', key: 'status', type: 'select', options: [{ value: 0, label: '正常' }, { value: 1, label: '禁止登录'}] },
];
const columns = [
  { name: '编号', key: 'user_id', width: '70px' },
  { name: '基础信息', key: 'baseInfo', type: 'custom', width: '300px'},
  { name: '会员等级', key: 'level', width: '70px'},
  { name: '积分', key: 'pay_points' },
  { name: '性别', key: 'sex', type: 'custom', width: '70px' },
  { name: '生日', key: 'birthday' },
  { name: '审核状态', key: 'is_apply', type: 'custom'  },
  { name: '操作', key: 'operate', type: 'custom', width: '400px'}
];
  export default {
    name: 'userList',
    components: { UserEnterprise, UserIntegral, ReceivingAddress },
    data() {
      return {
        columns,
        status,
        tableData: [],
        searchFields,
        searchValue: {},
        loading: false,
        pageOption: {
          total: 0,
          page: 1,
          page_size: 20,
        },
      }
    },
    created() {
      this.getList();
    },
    methods: {
      async getList() {
        this.loading = true;
        const data = await UserService.getList({...this.searchValue, page: this.pageOption.page, page_size: this.pageOption.page_size});
        this.loading = false;
        this.pageOption.total = data.totalRow;
        this.pageOption.page = data.page;
        this.tableData = data.list;
      },
      pageChange(index) {
        this.pageOption.page = index;
        this.getList();
      },
      search(data) {
        this.searchValue = data;
        this.getList()
      },
      editUser(type,data) {
        UserService.getList({...this.searchValue, page: this.pageOption.page, page_size: this.pageOption.page_size}).then(res=>{
          this.$router.push({path:'/userEdit',query:{type:type,data:data,userList:res.list}})
        })
      },
      openEnterprise(data) {
        this.$refs.userEnterprise.open('add', data);
      },
      openReadEnterprise(data) {
        this.$refs.userEnterprise.open('read', data);
      },
      openAuditEnterpreise(data) {
        this.$refs.userEnterprise.open('audit', data);
      },
      openChangeEnterprise(data) {
        this.$refs.userEnterprise.open('edit', data);
      },
      addressList(data) {
        this.$refs.ReceivingAddress.open(data);
      },
      openIntegral(data) {
        this.$refs.userIntegral.open(data);
      },
      menuClick({item, key}) {
        if (key === 1) {
          this.openAuditEnterpreise(item);
        } else if (key === 2) {
          item.is_apply === 0 ? this.openEnterprise(item) : this.openChangeEnterprise(item);
        } else if (key === 3) {
          this.openIntegral(item);
        } else if (key === 4) {
          this.addressList(item);
        }
      }
    }
  }
</script>

<style lang="scss" scoped>

.userList {
  
}
.baseInfo {
  display: flex;
  align-items: center;
  .content {
    margin-left: 20px;
    display: flex;
    flex-direction: column;
  }
}
</style>